import { Component, Input, ViewChild } from '@angular/core';

import { ClienteAnaliseMercadoFilter } from '../../adapters';

import { ClienteAnaliseMercadoClienteListComponent } from '../../cliente';

@Component({
    selector: 'sgt-cliente-analise-mercado-perspectiva-classificacao',
    templateUrl: './cliente-analise-mercado-perspectiva-classificacao.component.html',
    styleUrls: ['./cliente-analise-mercado-perspectiva-classificacao.component.less']
})
export class ClienteAnaliseMercadoPerspectivaClassificacaoComponent {
    @Input() isVisualizacaoModoList: boolean;
    @Input() filter: ClienteAnaliseMercadoFilter;

    @ViewChild('clienteList') clienteList: ClienteAnaliseMercadoClienteListComponent;

    search() {
        if (this.isVisualizacaoModoList) { // List
            this.clienteList?.search();
        }
    }
}
